<template>
    <HeaderContent title="Payment Method" />
    <ActionContent
        ctaText="Payment Method"
        :filterDate="false"
        :filterModal="false"
        @action="openAddModal"
        @search-query="getAll"
    />
    <PaymentMethodForm
        :modal="modal"
        :selectedData="selectedData"
        @update:modal="updateModal"
        @addOrUpdate="getAll"
    />

    <DataTable
        :data="dataList"
        :header="headers"
        :custom-actions="customActions"
    />
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import PaymentMethodForm from "./PaymentMethodForm.vue";
import DataTable from "@/components/DataTable.vue";
import { ref, onMounted, inject } from "vue";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";

const auth = useAuthStore();
const $loading = useLoading();
const selectedData = ref({});
const modal = ref(false);
const swal = inject("$swal");
const toast = useToast();

const headers = ref([
    { key: "no", label: "No", sortable: false },
    { key: "type", label: "Type", sortable: true },
    { key: "name", label: "Bank Name", sortable: true },
    { key: "owned_by", label: "Account Name", sortable: true },
    { key: "number", label: "Account Number", sortable: true },
    { key: "swift_code", label: "SWIFT Code", sortable: true },
    { key: "status", label: "Status", sortable: false },
    { key: "action", label: "Action" },
]);

const customActions = ref([
    {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
            selectedData.value = { ...item };
            modal.value = true;
        },
    },
    {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
            swal({
                title: "Confirm",
                text: "Are you sure to delete this payment method?",
                showCancelButton: true,
                confirmButtonText: "Yes, delete!",
                cancelButtonText: "Cancel",
                customClass: {
                    popup: "rounded",
                    confirmButton: "btn btn-danger me-2",
                    cancelButton: "btn btn-secondary",
                },
                buttonsStyling: false,
            }).then((confirm) => {
                if (confirm.value) {
                    deleteData(item.uuid);
                }
            });
        },
    },
]);

const openAddModal = () => {
    selectedData.value = {};
    modal.value = true;
};

const updateModal = (newValue) => {
    modal.value = newValue;
};

const dataList = ref([]);

const getAll = async (search = "") => {
    const loader = $loading.show({ color: "#489464", loader: "spinner" });
    try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/payment-method`, {
            params: { search },
            headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + auth._token,
            },
        });

        if (response.data.status) {
            dataList.value = response.data.data;
        }
    } finally {
        loader.hide();
    }
};

const deleteData = async (uuid) => {
    const loader = $loading.show({ color: "#009689", loader: "bars", zIndex: 999999 });
    try {
        const response = await axios.delete(
            `${process.env.VUE_APP_API_URL}/payment-method/delete/${uuid}`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        if (response.data.status) {
            toast.success(response.data.message);
            getAll();
        } else {
            toast.error(response.data.message);
        }
    } finally {
        loader.hide();
    }
};

onMounted(() => {
    getAll();
});
</script>
